import { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./NoticeGroupsUIHelpers";

const NoticeGroupsUIContext = createContext();

export function useNoticeGroupsUIContext() {
  return useContext(NoticeGroupsUIContext);
}

export const NoticeGroupsUIConsumer = NoticeGroupsUIContext.Consumer;

export function NoticeGroupsUIProvider({ noticeGroupsUIEvents, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);
  
  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams,
    openNewNoticeGroupPage: noticeGroupsUIEvents.openNewNoticeGroupPage,
    openEditNoticeGroupPage: noticeGroupsUIEvents.openEditNoticeGroupPage,
  };

  return (
    <NoticeGroupsUIContext.Provider value={value}>
      {children}
    </NoticeGroupsUIContext.Provider>
  );
}